export default "__VITE_ASSET__SWJ2oCfs__"